
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nova/drops",
      function () {
        return require("private-next-pages/nova/drops.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nova/drops"])
      });
    }
  